<template>
    <div>
        <hr>
        <div class="p-2">
            <div class="text-center p-2 pb-4">
                <span class="h5 font-weight-light"><i class="fa fa-clock-o"></i> {{transEdit('upcoming-bookings')}}</span>
            </div>

            <div class="d-flex flex-column" v-if="(newbookings && newbookings.length > 0)">
                <div v-for="schedule in newbookings" class="border rounded mt-2 mb-2 p-2 d-flex justify-content-between">
                    <template>
                        <div>
                            <div class="h6 font-weight-bold">{{getDateTime(schedule.start, schedule.end)}}</div>
                            <div class="text-muted">{{schedule.location.name}} {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                            <div class="text-muted">{{schedule.treatment.name}}</div>
                            <div class="text-muted"><img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}</div>
                        </div>
                        <div v-if="!schedule.confirmed" class="d-flex flex-column justify-content-around">
                            <div class="text-center">{{transEdit('only-reservations')}}</div>
                            <div>
                                <a href="/portal" class="btn btn-outline-primary">
                                    <i class="fa fa-calendar"></i> {{transEdit('make-booking')}}</a>
                            </div>
                        </div>
                        <div v-else-if="schedule.preliminaryCancellation" class="d-flex flex-column justify-content-around">
                            <button class="btn btn-outline-primary" type="button"
                                    @click="showPreliminaryUnbookingInfoModal">
                                <i class="fa fa-warning"> {{transEdit('provisional-cancellation')}}</i>
                            </button>
                        </div>
                        <div v-else class="d-flex flex-column justify-content-around">
                            <button class="btn btn-sm btn-outline-danger" type="button"
                                    @click="showCancellationModal(schedule, !isCancellableWithoutPrelim(schedule.cancellationLimit))"
                            ><i class="fa fa-times-circle-o"></i> {{transEdit('unbook')}}</button>
                        </div>
                    </template>
                </div>
            </div>

            <div v-else>
                <span>{{transEdit('no-upcoming-bookings')}}</span>
            </div>
        </div>
        <div v-if="(oldbookings && oldbookings.length > 0)" class="mt-4">
            <hr>
            <div class="text-center p-2 pb-4 clickable collapsed" data-toggle="collapse" data-target="#historical-bookings-container">
                <span class="h5 font-weight-light"><i class="fa fa-history"></i> {{transEdit('booking-history')}}</span>
            </div>

            <div id="historical-bookings-container" class="collapse" v-if="(oldbookings && oldbookings.length > 0)">
                <div v-for="schedule in oldbookings" class="border rounded mt-2 mb-2 p-2 d-flex justify-content-between">
                    <div>
                        <div class="h6 font-weight-bold">{{getDateTime(schedule.start, schedule.end)}}</div>
                        <div class="text-muted">{{schedule.location.name}} {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                        <div class="text-muted">{{schedule.treatment.name}}</div>
                        <div class="text-muted">{{schedule.therapist.user.name}}</div>
                    </div>
                    <div class="d-flex flex-column justify-content-around">
                        <a :href="'/receipt/' + schedule.bookingId" class="btn btn-outline-primary">
                            <i class="fa fa-calendar"></i> {{transEdit('receipt')}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'part'
        ],
        name: "customer-dash-bookings",
        methods: {
            getDateTime(dateString, dateStringEnd){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' + moment(dateString).format('HH:mm') + ' - ' + moment(dateStringEnd).format('HH:mm');
            },
            getDate: function (dateString) {
                let tempDate = new Date(dateString);

                return tempDate.getYMD();
            },
            getHrsMins: function (dateString) {
                let tempDate = new Date(dateString);
                let hrsMins = tempDate.getHrsMins();

                return hrsMins;
            },
            getStartToEndHrsMins: function (startDateString, endDateString) {
                let startHrsMins = this.getHrsMins(startDateString);
                let endHrsMins = this.getHrsMins(endDateString);

                return startHrsMins + " - " + endHrsMins;
            },
            isCancellableWithoutPrelim: function (cancellationLimit) {
                let tempDate = new Date(cancellationLimit);
                let now = new Date();

                if (tempDate > now) {
                    return true;
                }
                return false;
            },
            isCancellable: function (startDate) {
                let tempDate = new Date(startDate);
                let now = new Date();

                if (tempDate > now) {
                    return true;
                }
                return false;
            },
            route_cancel: function (booking) {
                return this.part.route_cancel + "/" + booking.bookingId;
            },
            showPreliminaryUnbookingInfoModal: function () {
                $("#preliminary-cancellation-info-modal").modal("show");
            },
            getCancellationLimitDateText: function (limit) {
                return new moment(limit).format('YYYY-MM-DD');
            },
            getCancellationLimitTimeText: function (limit) {
                return new moment(limit).format('HH:mm');
            },
            showCancellationModal: function (booking, isPreliminary = false) {
                let cancellationModal = $("#cancel-booking-modal");

                let cancellationModalPrelimWarning = $("#cancel-booking-modal-prelim-warning");
                let cancellationModalPrelimInformation = $("#cancellation-limit-container");
                let cancellationLimitDateSpan = $("#cancellation-limit-date-span");
                let cancellationLimitTimeSpan = $("#cancellation-limit-time-span");

                if (isPreliminary) {
                    cancellationModalPrelimWarning.show();
                    cancellationModalPrelimInformation.hide();
                } else {
                    cancellationModalPrelimWarning.hide();
                    cancellationLimitDateSpan.text(this.getCancellationLimitDateText(booking.cancellationLimit));
                    cancellationLimitTimeSpan.text(this.getCancellationLimitTimeText(booking.cancellationLimit));
                    cancellationModalPrelimInformation.show();
                }

                let cancellationModalTime = $("#cancel-booking-modal-time");
                let cancellationModalTreatment = $("#cancel-booking-modal-treatment");
                let cancellationModalLocation = $("#cancel-booking-modal-location");
                let cancellationModalTherapist = $("#cancel-booking-modal-therapist");
                let cancellationModalId = $("#cancel-booking-modal-id");
                let bookingDate = new Date(booking.start);

                let tempAddressString = booking.location.name;
                if (booking.location.city) {
                    tempAddressString += ' ' + booking.location.city.name;
                }

                cancellationModalTreatment.text(booking.treatment.name);
                cancellationModalTime.text(this.getDateTime(bookingDate));
                cancellationModalLocation.text(tempAddressString);
                cancellationModalTherapist.text(booking.therapist.user.name);
                cancellationModalId.val(booking.bookingId);

                cancellationModal.modal('show');
            },
        },
        computed: {
            oldbookings: function () {
                return this.part.oldbookings;
            },
            newbookings: function () {
                return this.part.newbookings;
            }
        },
        mounted () {
        }
    }
</script>

<style scoped>

</style>
